import React from "react";
import styled from "styled-components";
import { slide as BurgerMenu } from "react-burger-menu";

import { menuItems } from "components/Menu";
import useAuth from "hooks/useAuth";

function SideMenu(props: any) {
  const { requestLogout } = useAuth();

  const menuStyles = Object.assign(styles, {
    bmBurgerBars: {
      background: props.selectedTheme === "light" ? "#000" : "#FFF",
    },
  });

  return (
    <Container theme={props.theme}>
      <BurgerMenu {...props} styles={menuStyles} className="bg-menu">
        {menuItems.map(({ name, href }) => (
          <a href={href} className="menu-item" key={name}>
            {name}
          </a>
        ))}
        <Button onClick={requestLogout}>Logout</Button>
      </BurgerMenu>
    </Container>
  );
}

const styles = {
  bmBurgerButton: {
    position: "fixed",
    width: "2.25rem",
    height: "1.75rem",
    left: "1rem",
    top: "1rem",
  },
  bmBurgerBars: {
    background: "#373a47",
  },
  bmBurgerBarsHover: {
    background: "#a90000",
  },
  bmCrossButton: {
    height: "1.5rem",
    width: "1.5rem",
  },
  bmCross: {
    background: "#bdc3c7",
  },
  bmMenuWrap: {
    position: "fixed",
    height: "100%",
    width: "auto",
  },
  bmMenu: {
    background: "#373a47",
    padding: "2.5em 1.5em 0",
    fontSize: "1.15em",
    width: "12rem",
  },
  bmMorphShape: {
    fill: "#373a47",
  },
  bmItemList: {
    color: "#b8b7ad",
    padding: "0.8em",
    display: "flex",
    flexDirection: "column",
  },
  bmItem: {
    display: "inline-block",
    textDecoration: "none",
    color: "white",
    marginBottom: "1rem",
    outline: 0,
  },
  bmOverlay: {
    background: "rgba(0, 0, 0, 0.3)",
  },
};

const Container = styled.div`
  background-color: ${({ theme }) => theme.menuBackground};
  width: 100%;
  height: 3.6rem;
  position: fixed;
`;

const Button = styled.button`
  color: #fff;
  background: transparent;
  border: 0;
  font-size: 18.4px;
  padding: 0;
  margin-bottom: 0;
  text-align: left;
`;

export default SideMenu;
